<script setup lang="ts">
/*
 *
 * IMPORTS
 *
 * */

// Vue, router
import { computed } from 'vue'
import { type RouteLocationRaw, useRoute } from 'vue-router'

// PrimeVue
import { default as PButton } from 'primevue/button'

// Custom components and types
import CBaseHeader from '@/presentation/components/base/CBaseHeader.vue'
import type { LearningModule } from '@/core/domain/learning/module/LearningModule.ts'
import type { LearningGrain } from '@/core/domain/learning/grain/LearningGrain.ts'
import type { ReferentialTask } from '@/core/domain/referential/task/ReferentialTask.ts'
import type { LearningCourse } from '@/core/domain/learning/course/LearningCourse.ts'
import { QuizType } from '@/core/domain/resources/enums/QuizType.ts'

// Utils
const route = useRoute()

// Props
const props = defineProps<{
  learningModule: LearningModule | null
  learningGrain: LearningGrain | null
  backTo: RouteLocationRaw
  learningCourse: LearningCourse
  task: ReferentialTask | null
}>()

// Computed
const quizTypeText = computed(() => {
  switch (route.query.quizType) {
    case QuizType.Values.PRE:
      return 'de début de grain'
    case QuizType.Values.POST:
      return 'de fin de grain'
    case QuizType.Values.DIAG_START:
      return 'de diagnostic T1'
    case QuizType.Values.DIAG_END:
      return 'de diagnostic T2'
    default:
      return ''
  }
})

const backToText = computed(() => {
  if (route.query.quizType === (QuizType.Values.PRE || QuizType.Values.POST)) {
    return '< Retour au module'
  } else if (
    route.query.quizType === QuizType.Values.DIAG_START ||
    route.query.quizType === QuizType.Values.DIAG_END
  ) {
    return `< Revenir à l'édition du parcours "${props.learningCourse?.title}"`
  } else {
    return '< Retour au module'
  }
})

const titleText = computed(() => {
  if (props.learningModule?.id) {
    return `MODULE : ${props.learningModule.id}: ${props.learningModule.title}`
  } else {
    return `Tâche : ${props.task?.title}`
  }
})

const quizTitle = computed(() => {
  if (props.learningGrain?.title) {
    return `Quiz ${quizTypeText.value} : ${props.learningGrain.title}`
  } else {
    return `Quiz ${quizTypeText.value}`
  }
})
</script>

<template>
  <c-base-header
    :title="quizTitle"
    :subtitle="titleText"
    :display-breadcrumbs="false"
    has-widget
    class="border-surface border-b bg-white pb-2"
  >
    <template #breadcrumbs>
      <router-link :to="backTo" class="text-muted-color no-underline"
        >{{ backToText }}
      </router-link>
    </template>

    <template #widgets>
      <div class="col flex h-full items-center justify-end gap-4">
        <p-button
          label="Enregistrer le quiz et quitter"
          severity="primary"
          size="small"
          class="whitespace-nowrap"
          @click="$emit('save')"
        />
      </div>
    </template>
  </c-base-header>
</template>
